import { makeStyles } from '@mui/styles';
import { colors, radii } from '@components/design-system/tokens';

export const useStyles = makeStyles((theme: any) => ({
    menuButton: {
        padding: 8,
        borderRadius: `${radii.md}px`,
        color: colors.neutral[600],
        transition: 'all 150ms ease',

        '&:hover': {
            backgroundColor: colors.neutral[100],
            color: colors.neutral[900],
        },

        '& svg': {
            fontSize: 24,
        },

        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
}));
